import React from 'react';

const ChevronRight = () => {
    return (
        <img src="/assets/images/right.png"/>
    );
};

export default ChevronRight;
